"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const date_1 = require("../../formatters/date");
const dateFunctions = __importStar(require("../../utils/dateFunctions"));
const useStyles = makeStyles_1.default((theme) => ({
    dayChangeMarker: {
        padding: "6px 12px",
        borderRadius: 10,
        color: theme.colors.dayChangeMarker.textColor,
        backgroundColor: theme.colors.dayChangeMarker.backgroundColor,
        alignSelf: "center",
        position: "sticky",
        top: 10,
        zIndex: 60
    }
}));
exports.default = react_1.default.memo(DayChangeMarker);
function DayChangeMarker(props) {
    const classes = useStyles();
    return react_1.default.createElement(Typography_1.default, { variant: "body2", className: classes.dayChangeMarker }, formatDate(props.date));
}
function formatDate(date) {
    const startOfToday = dateFunctions.getStartOfToday();
    if (date >= startOfToday) {
        return "Today";
    }
    const startOfYesterday = dateFunctions.addDays(startOfToday, -1);
    if (date >= startOfYesterday) {
        return "Yesterday";
    }
    const useDayNameOnly = date >= dateFunctions.addDays(startOfToday, -6);
    return useDayNameOnly
        ? date_1.toDayOfWeekString(date)
        : date_1.toLongDateString(date);
}
